module.exports = __webpack_public_path__ + "static/media/animated-es.cb8813bb.gif";